import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Divider, Flex, Text } from 'pcln-design-system'
import { Content } from '@pcln/ace-content-react'
import { findIndex, propEq } from 'ramda'
import * as PCLNAnalytics from '../../utils/PCLN-Analytics'

import {
  CRUISE_PRODUCT_TYPE,
  FLIGHT_PRODUCT_TYPE,
  HOTEL_PRODUCT_TYPE,
  RENTAL_CAR_PRODUCT_TYPE,
  VACATION_PACKAGE_PRODUCT_TYPE
} from '../../constants/Constants'

const TABS = [
  {
    autobotID: 'DASH_TAB_HOTELS',
    name: 'Hotels',
    id: HOTEL_PRODUCT_TYPE,
    search: `?tab=${HOTEL_PRODUCT_TYPE}`
  },
  {
    autobotID: 'DASH_TAB_FLIGHTS',
    name: 'Flights',
    id: FLIGHT_PRODUCT_TYPE,
    search: `?tab=${FLIGHT_PRODUCT_TYPE}`
  },
  {
    autobotID: 'DASH_TAB_HOTEL + FLIGHT',
    name: 'Hotel + Flight',
    id: VACATION_PACKAGE_PRODUCT_TYPE,
    search: `?tab=${VACATION_PACKAGE_PRODUCT_TYPE}`
  },
  {
    autobotID: 'DASH_TAB_CARS',
    name: 'Cars',
    id: RENTAL_CAR_PRODUCT_TYPE,
    search: `?tab=${RENTAL_CAR_PRODUCT_TYPE}`
  },
  {
    autobotID: 'DASH_TAB_CRUISES',
    name: 'Cruises',
    id: CRUISE_PRODUCT_TYPE,
    search: `?tab=${CRUISE_PRODUCT_TYPE}`
  }
]

const Tab = styled.li`
  width: 20%;
  text-align: center;
  display: inline-block;
  &:hover {
    cursor: pointer;
  }
  &:focus > * {
    color: ${props => props.theme.colors.blue};
  }
`

const TabLink = Tab.withComponent(Link)

const TabLabel = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors[props.fontColor]};
  &:hover {
    color: ${props => props.theme.colors.blue};
  }
`
const StyledDivider = styled(Divider)`
  height: .25rem;
  padding: 0;
  width: 20%;
  background: ${props => props.theme.colors.blue};
  border: none;
  transition: .3s ease-in-out;
`

function ProductTabs ({ currentTab }) {
  const currentTabIndex = findIndex(propEq('id', currentTab), TABS)
  const marginLeft = `${currentTabIndex * 20}%`
  // @todo move analytics call into useEffect
  return (
    <Flex flexDirection='column' data-autobot-element-id='PRODUCT_TABS' >
      <ul style={{ padding: 0, margin: 0 }} role='tablist'>
        {TABS.map(({ autobotID, id, name, search }) => (
          <TabLink
            id={`search-tab-${id}`}
            key={id}
            data-autobot-element-id={autobotID}
            onClick={() => {
              PCLNAnalytics.send({
                category: 'PCLN_HOME',
                action: 'Field Click',
                data: `${currentTab} - tab`
              })
            }}
            to={{ search }}
            role='tab'
            aria-controls={id + '_tab'}
          >
            <TabLabel
              py={12}
              fontColor={currentTab === id ? 'blue' : 'gray'}
            >
              <Content
                name={[`SITE-X.HOMEPAGE.SEARCHAREA.${id === 'vacations' ? 'PACKAGES' : name.toUpperCase()}TAB.TABLINK`]}
                fallback={name.toUpperCase()}
              />
            </TabLabel>
          </TabLink>
        ))}
      </ul>
      <StyledDivider ml={marginLeft} my={0} />
    </Flex>
  )
}

ProductTabs.propTypes = {
  currentTab: PropTypes.string.isRequired
}

export default ProductTabs
